"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductAmount = void 0;
const constants_1 = require("root/src/shared/rewards/constants");
const getProductAmount = (product) => {
    if (!product) {
        return 0;
    }
    if (product.type === constants_1.RewardType.CUSTOM) {
        return Infinity;
    }
    return product.productsAvailable || 0;
};
exports.getProductAmount = getProductAmount;
